<template>
<div class="chapter">
<div class="inner_page">
<p class="center" id="ded"><a id="pagev"></a>For Ollie Cosman<br/>and Chandler Lyell</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?791bf214